import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense, useMemo } from 'react';
import ReactModal from 'react-modal';
import { useTheme } from 'styled-components';
import { Button } from '../../Controls/Button';
import Icons from '../../Elements/Icons';
import { Loader } from '../../Elements/Loader';
import { InfoTooltipIcon } from '../InfoTooltipIcon';
import { DEFAULT_MODAL_ZINDEX, MODAL_ANIMATION_DURATION_MS } from './constants';
import { Header, Wrapper, StyledModal, Body, Footer, TitleWrapper, Title } from './styled';
const appEl = document.getElementById('root') || document.body;
ReactModal.setAppElement(appEl);
if (ReactModal.defaultStyles.overlay) {
    ReactModal.defaultStyles.overlay.zIndex = DEFAULT_MODAL_ZINDEX;
}
const ModalComponent = ({ children, state, title, width = '700px', height = 'auto', shouldCloseOnOverlayClick = true, zIndex = DEFAULT_MODAL_ZINDEX, scroll, tooltip, ...props }) => {
    const { colors } = useTheme();
    const modalStyles = useMemo(() => ({ overlay: { zIndex, backgroundColor: 'rgba(0, 0, 0, 0.4)' } }), [zIndex]);
    return (_jsx(StyledModal, { isOpen: state.isOpen, onRequestClose: state.close, onAfterClose: state.afterClose, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, closeTimeoutMS: MODAL_ANIMATION_DURATION_MS, width: width, height: height, scroll: scroll, style: modalStyles, ...props, children: _jsx(Suspense, { fallback: _jsx(Loader, { cover: true }), children: _jsxs(Wrapper, { "data-test": 'modal-window', children: [title ? (_jsxs(Header, { children: [_jsxs(TitleWrapper, { "data-testid": 'modal-window-title', children: [_jsx(Title, { children: title }), tooltip && _jsx(InfoTooltipIcon, { tooltip: tooltip })] }), _jsx(Button, { ghost: true, iconOnly: true, onClick: state.close, "data-testid": 'close-button-modal-window', children: _jsx(Icons.Close, { size: 24, color: colors.grey100_1 }) })] })) : null, children] }) }) }));
};
export const Modal = Object.assign(ModalComponent, {
    Body,
    Footer,
});
